// extracted by mini-css-extract-plugin
export var dropdown = "_s7-0";
export var imageWrapper = "_s7-3";
export var itemNameContainer = "_s7-1";
export var productImage = "_s7-2";
export var spinnerWrapper = "_s7-4";